$(function(){
	var ESlider = function(slider, images) {
		var _ = function(selector) {
			return document.querySelector(selector);
		}
	
		var __ = function(selector) {
			return document.querySelectorAll(selector);
		}
	
		this.slider = _(slider);
		
		this.images = images;
		this.slides = "";
		this.currentSlide;
		
		this.slider.classList.add("ESlider");
		
		this.slides = "";
		this.bulks = "<div class='ESlider-bulks-container'>";
		this.images.forEach(function(image, index) {
			
			var active_class = (index === 0) ? ' ESlider-active-slide ' : '';
			
			this.slides += "<img class='ESlider-slide ESlider-slide-" + (index + 1) + active_class + "' src='" + image + "' />";
			this.bulks += "<span class='ESlider-bulk' data-slide-id='"+ (index+1) + "'><img src='" + image + "' class='ESlider-thumbnail' /></span>";
		}.bind(this));
	
		this.bulks += "</div>";
		this.contronls = "<span class='ESlider-previous'></span><span class='ESlider-next'></span>";
		this.slider.innerHTML += this.slides + this.bulks + this.contronls;
	
		this.interval = function() {
			this.autoSlide = setInterval(function() {
				this.next();
			}.bind(this), 5000);
		}.bind(this);
	
		this.setSlide = function(id) {
			clearInterval(this.autoSlide);
			if(!_(slider + " .ESlider-active-slide"))
				return;
			
			if (_(slider + " .ESlider-active-slide") !== null)
				_(slider + " .ESlider-active-slide").classList.remove("ESlider-active-slide");
	
			if (_(slider + " .ESlider-active-bulk") !== null)
				_(slider + " .ESlider-active-bulk").classList.remove("ESlider-active-bulk");
	
			_(slider + " .ESlider-slide-" + id).classList.add("ESlider-active-slide");
			_(slider + " .ESlider-bulk[data-slide-id='" + id + "']").classList.add("ESlider-active-bulk");
			
			var curr_height_listener = setInterval(function(){
				if( $(slider + " .ESlider-slide-" + id).hasClass('ESlider-active-slide') )
					_(slider).style.height = _(slider + " .ESlider-slide-" + id).clientHeight + "px";
				else
					clearInterval(curr_height_listener);
			},200);
			this.currentSlide = id;
			
			this.interval();
		}
	
		this.next = function() {
			
			if (this.currentSlide == this.images.length)
				this.currentSlide = 1;
			else
				this.currentSlide++;
			this.setSlide(this.currentSlide);
		}
		
		this.previous = function() {
			if (this.currentSlide == 1)
				this.currentSlide = this.images.length;
			else
				this.currentSlide--;
			this.setSlide(this.currentSlide);
		}
		
		var bulks = __(slider + " .ESlider-bulk");
		for (var i = 0; i < bulks.length; i++) {
			bulks[i].addEventListener("click", function(e) {
				var slideID = e.target.dataset.slideId;
				this.setSlide(slideID);
			}.bind(this));
		}
		
		_(slider + " .ESlider-previous").addEventListener("click", function(e) {
			this.previous();
		}.bind(this));
		
		_(slider + " .ESlider-next").addEventListener("click", function(e) {
			this.next();
		}.bind(this));
		
		this.setSlide(1);
	};	
	
	var resources_prefix = WebSystem.get_resources_prefix('contents');
	
	var slider = new ESlider("#slider-1", [
		resources_prefix + "assets/web_contents/01.jpg",
		resources_prefix + "assets/web_contents/02.jpg",
		resources_prefix + "assets/web_contents/03.jpg",
		resources_prefix + "assets/web_contents/04.jpg",
		resources_prefix + "assets/web_contents/05.jpg",
		resources_prefix + "assets/web_contents/06.jpg",
		resources_prefix + "assets/web_contents/07.jpg",
		resources_prefix + "assets/web_contents/08.jpg"
	]);
});